import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthRoute from './AuthRoute';
import './css/app.css';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsInitializer from './components/AnalyticsInitializer';
import ThemeManager from './components/ThemeManager';

// auth
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Verify from './pages/auth/Verify';

//password forgot
import PasswordForget from './pages/password-reset/PasswordForget';

//guest
import TermsAndConditions from './pages/guest/TermsAndConditions';
import PrivacyPolicy from './pages/guest/PrivacyPolicy'
import CookiePolicy from './pages/guest/CookiePolicy'

//support
import ContactSupport from './pages/support/ContactSupport'

//intro
import Welcome from './pages/intro/Welcome';

//forecast
import Map from './pages/forecast/Map';
import SpotForecast from './pages/forecast/SpotForecast';
import SpotsForecast from './pages/forecast/SpotsForecast';

//account
import AccountOverview from './pages/account/AccountOverview';
import AccountEdit from './pages/account/AccountEdit';

//locations
import SpotSave from './pages/locations/SpotSave';
import SpotEdit from './pages/locations/SpotEdit';
import SpotOverview from './pages/locations/SpotOverview';
import SpotEditPreferences from './pages/locations/SpotEditPreferences';

//error
import Page404 from './pages/error/Page404'

//alerts
import Alerts from './pages/alerts/Alerts'

//settings
import Options from './pages/settings/Options'

//info
import Info from './pages/info/Info'

const App = () => {
    return (
        <Router>
            <ThemeManager />
            <AnalyticsInitializer>
                <ScrollToTop />
                {/* <Logo />
                <Navigation /> */}
                <Routes>

                {/* auth */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/verify" element={<Verify />} />

                {/* password forget */}
                <Route path="/password-reset" element={<PasswordForget />} />
                <Route path="/reset-password" element={<PasswordForget />} />

                {/* guest */}
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />

                {/* support */}
                <Route path="/support" element={<ContactSupport />} />

                {/* protected routes */}

                <Route path="/welcome" element={
                    <AuthRoute>
                        <Welcome />
                    </AuthRoute>
                } />

                <Route path="/" element={
                    <AuthRoute>
                        <Map />
                    </AuthRoute>
                } />

                <Route path="/about" element={
                    <AuthRoute>
                        <Map />
                    </AuthRoute>
                } />

                <Route path="/contact" element={
                    <AuthRoute>
                        <Map />
                    </AuthRoute>
                } />

                <Route path="/saved-spots" element={
                    <AuthRoute>
                        <SpotsForecast />
                    </AuthRoute>
                } />

                <Route path="/location/forecast" element={
                    <AuthRoute>
                        <SpotForecast />
                    </AuthRoute>
                } />

                <Route path="/location/save" element={
                    <AuthRoute>
                        <SpotSave />
                    </AuthRoute>
                } />

                <Route path="/location/:id/edit" element={
                    <AuthRoute>
                        <SpotEdit />
                    </AuthRoute>
                } />

                <Route path="/location/:id/preferences" element={
                    <AuthRoute>
                        <SpotEditPreferences />
                    </AuthRoute>
                } />

                <Route path="/location/:id/view" element={
                    <AuthRoute>
                        <SpotOverview />
                    </AuthRoute>
                } />

                <Route path="/location/:id/forecast" element={
                    <AuthRoute>
                        <SpotForecast />
                    </AuthRoute>
                } />

                <Route path="/account/overview" element={
                    <AuthRoute>
                        <AccountOverview />
                    </AuthRoute>
                } />

                <Route path="/account/edit" element={
                    <AuthRoute>
                        <AccountEdit />
                    </AuthRoute>
                } />

                <Route path="/options" element={
                    <AuthRoute>
                        <Options />
                    </AuthRoute>
                } />

                <Route path="/info" element={
                    <AuthRoute>
                        <Info />
                    </AuthRoute>
                } />

                <Route path="/alerts" element={
                    <AuthRoute>
                        <Alerts />
                    </AuthRoute>
                } />

                

                {/* 404 not found */}
                <Route path="*" element={<Page404 />} />
            </Routes>
            </AnalyticsInitializer>
        </Router>
    );
}

export default App;
